"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shortWeekDays = exports.months = void 0;
exports.months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];
var daysWithUniqueFormat = {
    '1': 'st',
    '2': 'nd',
    '3': 'rd'
};
exports.shortWeekDays = [
    'Sun',
    'Mon',
    'Tue',
    'Wed',
    'Thu',
    'Fri',
    'Sat'
];
function formatDateAndMonth(date, truncateMonth) {
    if (truncateMonth === void 0) { truncateMonth = true; }
    var dateFromString = new Date(date);
    var month = truncateMonth
        ? exports.months[dateFromString.getMonth()].slice(0, 3)
        : exports.months[dateFromString.getMonth()];
    var weekDay = exports.shortWeekDays[dateFromString.getDay()];
    var day = dateFromString.getDate().toString();
    var dayLength = day.length;
    var requiresSpecialFormatting = Object.keys(daysWithUniqueFormat).includes(day[dayLength - 1]) &&
        (dayLength === 1 || (dayLength === 2 && day[0] !== '1'));
    var formattedDay = requiresSpecialFormatting
        ? day + daysWithUniqueFormat[day[dayLength - 1]]
        : "".concat(day, "th");
    return "".concat(weekDay, ", ").concat(month, " ").concat(formattedDay);
}
exports.default = formatDateAndMonth;
//# sourceMappingURL=formatDateAndMonth.js.map